// THIS FILE IS GENERATED. Do not edit by hand.
// Source: shared/contract/types.ts
// Regenerate via: `pnpm contract:gen` (from web/) or `node shared/contract/codegen.mjs`.
//
// Handwritten Zod (BridgeResponseOkSchema<T>, BridgeResponseSchema<T>)
// lives in validate.ts and is preserved across regeneration.

import { z } from "zod";

export const BridgeErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  recoverable: z.boolean(),
  recoveryHint: z.string().optional(),
});

export const BridgeResponseErrorSchema = z.object({
  v: z.literal(1),
  ok: z.literal(false),
  id: z.string(),
  error: BridgeErrorSchema,
});

export const HandshakeResponseSchema = z.object({
  nativeApiVersion: z.number().int(),
  shellVersion: z.string(),
  iosVersion: z.string(),
  commitSha: z.string(),
  supportedMethods: z.array(z.string()),
  webBuildOrigin: z.union([z.literal("bundled"), z.literal("cached"), z.literal("remote"), z.literal("localhost")]).nullable().optional(),
  webBuildIsLatest: z.boolean().nullable().optional(),
});

export const DistanceSchema = z.object({
  value: z.number(),
  unit: z.string(),
});

export const WorkoutSummarySchema = z.object({
  uuid: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  activityType: z.string(),
  durationSeconds: z.number(),
  totalDistance: DistanceSchema.nullable().optional(),
  swimmingLocationType: z.union([z.literal("pool"), z.literal("openWater"), z.literal("unknown")]).nullable().optional(),
});

export const SwimFirehoseRequestSchema = z.object({
  workoutUUID: z.string().optional(),
});

export const FirehoseSampleEntrySchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
  value: z.number().nullable().optional(),
  sourceName: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  sourceIndex: z.number().int().nullable().optional(),
});

export const FirehoseTypeBucketSchema = z.object({
  typeName: z.string(),
  category: z.union([z.literal("quantity"), z.literal("category")]),
  unit: z.string().nullable().optional(),
  sampleCount: z.number().int(),
  samples: z.array(FirehoseSampleEntrySchema),
  error: z.string().nullable().optional(),
});

export const FirehoseWorkoutEventSchema = z.object({
  type: z.string(),
  date: z.string(),
  durationSeconds: z.number().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const FirehoseWorkoutActivitySchema = z.object({
  uuid: z.string(),
  activityType: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable().optional(),
  durationSeconds: z.number(),
  locationType: z.string().nullable().optional(),
  swimmingLocationType: z.string().nullable().optional(),
  events: z.array(FirehoseWorkoutEventSchema),
});

export const FirehoseRoutePointSchema = z.object({
  t: z.string(),
  lat: z.number(),
  lon: z.number(),
  alt: z.number().nullable().optional(),
  speedMps: z.number().nullable().optional(),
  course: z.number().nullable().optional(),
  hAcc: z.number().nullable().optional(),
});

export const FirehoseRouteSchema = z.object({
  points: z.array(FirehoseRoutePointSchema),
  sampleCount: z.number().int(),
});

export const FirehoseDeviceSchema = z.object({
  name: z.string().nullable().optional(),
  manufacturer: z.string().nullable().optional(),
  model: z.string().nullable().optional(),
  hardwareVersion: z.string().nullable().optional(),
  softwareVersion: z.string().nullable().optional(),
});

export const FirehoseSourceSchema = z.object({
  name: z.string().nullable().optional(),
  bundleIdentifier: z.string().nullable().optional(),
  version: z.string().nullable().optional(),
  productType: z.string().nullable().optional(),
  operatingSystemVersion: z.string().nullable().optional(),
  device: FirehoseDeviceSchema.nullable().optional(),
});

export const SwimFirehoseResponseSchema = z.object({
  workout: WorkoutSummarySchema,
  events: z.array(FirehoseWorkoutEventSchema),
  activities: z.array(FirehoseWorkoutActivitySchema),
  buckets: z.array(FirehoseTypeBucketSchema),
  route: FirehoseRouteSchema.nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  readerVersion: z.number().int().nullable().optional(),
  sources: z.array(FirehoseSourceSchema).nullable().optional(),
  workoutSourceIndex: z.number().int().nullable().optional(),
});

export const FirehoseProvenanceSchema = z.object({
  swimmerLabel: z.string().nullable().optional(),
  originId: z.string().nullable().optional(),
  readerVersion: z.number().int().nullable().optional(),
  exportedAt: z.string().nullable().optional(),
});

export const FirehoseExportEnvelopeSchema = z.object({
  schemaVersion: z.number().int(),
  payload: SwimFirehoseResponseSchema,
  provenance: FirehoseProvenanceSchema.nullable().optional(),
});

export const CompanionSummarySchema = z.object({
  originId: z.string(),
  swimmerLabel: z.string(),
  workoutCount: z.number().int(),
  lastSwimDate: z.string().nullable().optional(),
  schemaVersion: z.number().int(),
});

export const CompanionFirehoseRequestSchema = z.object({
  originId: z.string(),
});

export const CompanionLapLabelsRequestSchema = z.object({
  originId: z.string(),
  workoutUUID: z.string(),
});

export const ClubSwimFirehoseRequestSchema = z.object({
  memberId: z.string(),
  workoutUUID: z.string(),
});

export const LapLabelSchema = z.object({
  lapIndex: z.number().int(),
  kind: z.union([z.literal("rest"), z.literal("wall"), z.literal("outlier"), z.literal("drill"), z.literal("stroke-correction")]),
  customName: z.string().nullable().optional(),
  strokeOverride: z.string().nullable().optional(),
  excludedFromAggregates: z.boolean(),
  offsetSeconds: z.number().nullable().optional(),
  durationSeconds: z.number().nullable().optional(),
  duplicateOrdinal: z.number().nullable().optional(),
  provenance: z.union([z.literal("user-corrected"), z.literal("suggestion-accepted"), z.literal("user-confirmed")]).nullable().optional(),
  suggestedStroke: z.string().nullable().optional(),
  suggestionReasons: z.array(z.string()).nullable().optional(),
  detectorVersion: z.number().int().nullable().optional(),
  createdAtMs: z.number().nullable().optional(),
});

export const ClubSwimFirehoseResponseSchema = z.object({
  ok: z.boolean(),
  reason: z.union([z.literal("notStored"), z.literal("error")]).nullable().optional(),
  firehose: SwimFirehoseResponseSchema.nullable().optional(),
  labels: z.array(LapLabelSchema).nullable().optional(),
  labelsRevision: z.string().nullable().optional(),
  shareState: z.union([z.literal("saved"), z.literal("queued"), z.literal("rejected")]).nullable().optional(),
});

export const RemoveCompanionRequestSchema = z.object({
  originId: z.string(),
});

export const RemoveCompanionResponseSchema = z.object({
  ok: z.literal(true),
  removed: z.boolean(),
});

export const AttendanceEntrySchema = z.object({
  day: z.string(),
  memberId: z.string(),
});

export const MarkAttendanceRequestSchema = z.object({
  day: z.string(),
});

export const MarkAttendanceResponseSchema = z.object({
  ok: z.boolean(),
});

export const ClubStatusResponseSchema = z.object({
  iCloudOk: z.boolean(),
  accountMessage: z.string().nullable().optional(),
  role: z.union([z.literal("leader"), z.literal("member"), z.literal("none"), z.literal("unknown")]),
  optedIn: z.boolean(),
  myName: z.string().nullable().optional(),
});

export const SetClubNameRequestSchema = z.object({
  name: z.string(),
});

export const SetClubNameResponseSchema = z.object({
  ok: z.boolean(),
  name: z.string().nullable().optional(),
});

export const OpenClubSettingsResponseSchema = z.object({
  ok: z.literal(true),
});

export const GoalPreferencesSchema = z.object({
  weekDistanceMeters: z.number().nullable().optional(),
  peakHrBpm: z.number().nullable().optional(),
  ageYears: z.number().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const SetGoalsRequestSchema = z.object({
  prefs: GoalPreferencesSchema,
});

export const SetGoalsResponseSchema = z.object({
  prefs: GoalPreferencesSchema,
});

export const GetLapLabelsRequestSchema = z.object({
  workoutUUID: z.string().nullable().optional(),
});

export const SetLapLabelsRequestSchema = z.object({
  workoutUUID: z.string().nullable().optional(),
  clientLabelSchemaVersion: z.number().int().nullable().optional(),
  labels: z.array(LapLabelSchema),
});

export const SetLapLabelsResponseSchema = z.object({
  labels: z.array(LapLabelSchema),
});

export const TriggerHapticRequestSchema = z.object({
  style: z.union([z.literal("light"), z.literal("medium"), z.literal("heavy"), z.literal("soft"), z.literal("rigid"), z.literal("selection"), z.literal("success"), z.literal("warning"), z.literal("error")]),
});

export const TriggerHapticResponseSchema = z.object({
  ok: z.literal(true),
});

export const OpenRouteMapRequestSchema = z.object({
  workoutUUID: z.string(),
});

export const OpenRouteMapResponseSchema = z.object({
  ok: z.literal(true),
});

export const SelectTabRequestSchema = z.object({
  tab: z.union([z.literal("swim"), z.literal("sets"), z.literal("strokes"), z.literal("club")]),
  workoutUUID: z.string().nullable().optional(),
});

export const SelectTabResponseSchema = z.object({
  ok: z.boolean(),
});

export const ClubReactRequestSchema = z.object({
  swimId: z.string(),
  emoji: z.string().nullable(),
});

export const ClubReactResponseSchema = z.object({
  ok: z.boolean(),
});

export const BetaClubDiagnosticsSchema = z.object({
  role: z.union([z.literal("leader"), z.literal("member"), z.literal("none"), z.literal("unknown")]),
  memberCount: z.number().int().nullable().optional(),
  rosterSynced: z.boolean(),
  ownSwimSynced: z.boolean(),
  lastSync: z.string().nullable().optional(),
});

export const BetaDiagnosticsResponseSchema = z.object({
  appVersion: z.string(),
  buildNumber: z.string(),
  iosVersion: z.string(),
  deviceModel: z.string(),
  health: z.union([z.literal("allowed"), z.literal("not allowed"), z.literal("not asked")]),
  lastSwimDate: z.string().nullable().optional(),
  lastSwimPoolMeters: z.number().nullable().optional(),
  icloud: z.union([z.literal("signed in"), z.literal("signed out"), z.literal("restricted"), z.literal("unknown")]),
  club: BetaClubDiagnosticsSchema,
  locale: z.string(),
});

export const SendFeedbackRequestSchema = z.object({
  body: z.string(),
});

export const SendFeedbackResponseSchema = z.object({
  presented: z.union([z.literal("mail"), z.literal("share")]),
});

export const RequestHealthAccessResponseSchema = z.object({
  health: z.union([z.literal("allowed"), z.literal("not allowed"), z.literal("not asked")]),
});

export const OpenSettingsResponseSchema = z.object({
  ok: z.boolean(),
});

export const OpenDebugToolsResponseSchema = z.object({
  ok: z.boolean(),
});

export const LogRequestSchema = z.object({
  level: z.string(),
  message: z.string(),
});

export const LogResponseSchema = z.object({
  ok: z.boolean(),
});

export const ClubSnapshotResponseSchema = z.object({
  snapshot: z.record(z.string(), z.unknown()),
});

export const ListWorkoutsResponseSchema = z.array(WorkoutSummarySchema);

export const ListCompanionsResponseSchema = z.array(CompanionSummarySchema);

export const CompanionLapLabelsResponseSchema = z.array(LapLabelSchema);

export const ListAttendanceResponseSchema = z.array(AttendanceEntrySchema);

// (alias GetGoalsResponse = GoalPreferences — not auto-generated; handwrite in validate.ts if needed)

export const GetLapLabelsResponseSchema = z.array(LapLabelSchema);
